export const SET_SEARCH_LAWYERID = 'searchLawyer/set_search_lawyerId'
export const SET_SEARCH_REASON = 'searchLawyer/set_search_reason'
export const SET_SEARCH_KEYWORD_SELECTED = 'searchLawyer/set_search_keyword_selected'
export const RESET_SEARCH = 'searchLawyer/reset_search'

const initialState = {
  keywordSelected: null,
  reason: null,
  lawyerId: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_LAWYERID:
      return {
        ...state,
        lawyerId: action.payload,
      }
    case SET_SEARCH_REASON:
      return {
        ...state,
        reason: action.payload,
      }
    case SET_SEARCH_KEYWORD_SELECTED:
      return {
        ...state,
        keywordSelected: action.payload,
      }
    case RESET_SEARCH:
      return {
        ...initialState,
      }
    default:
      return state
  }
}

export default reducer
